export var UserRole;
(function (UserRole) {
    UserRole["SuperAdmin"] = "SuperAdmin";
    UserRole["CustomerSuperAdmin"] = "CustomerSuperAdmin";
    UserRole["CustomerAdmin"] = "CustomerAdmin";
    UserRole["ServiceAdmin"] = "ServiceAdmin";
    UserRole["Operator"] = "Operator";
})(UserRole || (UserRole = {}));
